module.exports = __webpack_public_path__ + "img/sigfoxcreategroup.1b76b7e6.png";